import React from 'react';
import GameAnimation from "../../../../dev/components/gameAnimation";
import GameVideo from "../gameVideo";
import {t} from "../../../../dev/helpers/translator";
import Config from "../../../../dev/config/main";

export default function gameAnimationTemplate () {
    if (!this.props.hasAnimation && !this.props.hasVideo) {
        return (null);
    }

    if (this.props.game.is_itf && !Config.main.showItfStatistics) {
        return null;
    } else {
        return (<div className="animation-video-wrapper">
            <div className={`animation-v-nav-view ${this.toggleEnabled ? 'collapsed' : 'expanded'}`}>
                <div className="tab-video-nav-b">
                    {
                        (this.props.hasVideo)
                            ? (<div className={`video-animation-button-m ${(this.activeTab === 'video' && this.props.hasAnimation) ? 'active' : ''}`} onClick={() => { this.toggleTab('video'); }}>{t("Video")}</div>)
                            : (null)
                    }

                    {
                        (this.props.hasAnimation)
                            ? (<div className={`video-animation-button-m ${(this.activeTab === 'animation' && this.props.hasVideo) ? 'active' : ''}`} onClick={() => { this.toggleTab('animation'); }}>{t("Animation")}</div>)
                            : (null)
                    }
                </div>
                <div className="arrow-toggle-view" onClick={() => { this.toggleExpanded(); }}/>
            </div>
            <div className="wrapper-v-a-view">
                {(() => {
                    switch (this.activeTab) {
                        case 'animation':
                            return (<GameAnimation game={this.props.game} sport={this.props.sportAlias}/>);
                        case 'video':
                            return (<GameVideo streamURL={this.props.streamURL} loggedIn={this.props.loggedIn} balance={this.props.balance}/>);
                        default :
                            return (null);
                    }
                })()}
            </div>
        </div>);
    }
};
